/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Wed Jun 28 2023
 **/

import { useTheme } from "@emotion/react";

import { Menu } from "@/frameworks/designStuff/components";
import { _T } from "@rfice/language";
import { useMinimizeChatList, usePopover } from "@/frameworks/core/hooks";
import { POPOVER_ID } from "@/frameworks/core/commons";

export default function MinimizeChatMore() {
	const theme = useTheme();
	const { minimizeChatListActions } = useMinimizeChatList();

	const { hide } = usePopover();

	const handleRemoveAll = () => {
		minimizeChatListActions.clear();
		hide(POPOVER_ID.MINIMIZE_CHAT_MORE);
	};

	return (
		<Menu css={{ background: theme.colors.neutral_00_100 }}>
			<Menu.List>
				<Menu.Item onClick={handleRemoveAll}>{_T("전체 삭제")}</Menu.Item>
			</Menu.List>
		</Menu>
	);
}
